import React, { useState } from 'react'
import "../../assets/style/eegisterProvider.css"
import TextField from '@mui/material/TextField';
import { Button, FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import components from '../../components';
import { Link,Outlet,useNavigate, useLocation } from 'react-router-dom';
import PurchasedDataUnit_DetailsTable from '../../components/Table/PurchasedDataUnit_DetailsTable';

const PurchasedDataUnit = () => {
    // Debug logging (moved inside component to avoid initialization errors)
    console.log('🚀 ~ components:', components);
    console.log('🚀 ~ components.Table:', components.Table);
    console.log('🚀 ~ components.Table.PurchasedDataUnit_DetailsTable:', components.Table.PurchasedDataUnit_DetailsTable);
    console.log('🚀 ~ Direct import PurchasedDataUnit_DetailsTable:', PurchasedDataUnit_DetailsTable);
    const navigate = useNavigate();
    const location = useLocation();
    const[ButData,setButData]=useState({
     SDL:"" ,
     Instrumente:"",
     TimeModus:"",
     Market:"",
     Time:""
})
const handleChange = (event) => {
     setButData({...ButData,[event.target.name]: event.target.value,});
};
    console.log('location', location)
    const goBack = () => {
      navigate(-1);
    };
  return (
    <>
     <div style={{width:"100%",backgroundColor:"#F3F4F8"}}>
     <span className='RegisterProviderText'>
   <div style={{display:"flex",justifyContent:"space-between"}}>
   <span style={{paddingLeft:20}}> <Button variant="contained"  onClick={goBack} style={{ marginRight: "20px",backgroundColor:"black" }}>
         {"< Back"}
        </Button>Transaction Details</span> 
   {/* <Button onClick={()=>{
    navigate('/admin-panel/CheckProviderDetail/RegisterNewDataProvider');
   }}  variant="contained">Register New Data Provider</Button>  */}
    </div>     
   

     </span>
            <div style={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"space-around",width:"100%"}}>
                           
                            <div style={{width:"98%",marginTop:40}}>
                                {components.Table.PurchasedDataUnit_DetailsTable ? (
                                    <components.Table.PurchasedDataUnit_DetailsTable/>    
                                ) : PurchasedDataUnit_DetailsTable ? (
                                    <PurchasedDataUnit_DetailsTable/>
                                ) : (
                                    <div style={{ padding: '20px', backgroundColor: '#f0f0f0', borderRadius: '8px' }}>
                                        <h3>Component Not Found</h3>
                                        <p>PurchasedDataUnit_DetailsTable component is undefined</p>
                                        <p>components.Table: {components.Table ? 'Exists' : 'Undefined'}</p>
                                        <p>components.Table.PurchasedDataUnit_DetailsTable: {components.Table?.PurchasedDataUnit_DetailsTable ? 'Exists' : 'Undefined'}</p>
                                        <p>Direct import PurchasedDataUnit_DetailsTable: {PurchasedDataUnit_DetailsTable ? 'Exists' : 'Undefined'}</p>
                                    </div>
                                )}
                            </div>  
                            
            </div>
         
</div>
</>
  )
}

export default PurchasedDataUnit